import { Text } from 'theme-ui';

type LocaleUpdatedAtProps = {
  value: Date | string;
  /** Overrides the default (compacted, no-seconds) tooltip with this exact text. */
  title?: string;
};

export const LocaleUpdatedAt = ({ value, title }: LocaleUpdatedAtProps) => {
  const date = new Date(value);
  const today = new Date();
  const dateString = date.toLocaleDateString();
  const todayString = today.toLocaleDateString();
  const formattedTime = date.toLocaleString('default', {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  });
  const formattedDate = date.toLocaleString('default', {
    month: 'short',
    day: 'numeric',
    // include year when its not current year
    year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined,
  });

  return (
    <Text
      sx={{ color: 'primaryText' }}
      title={title ?? `${formattedDate} ${formattedTime}`}
    >
      {dateString === todayString ? formattedTime : formattedDate}
    </Text>
  );
};
